

























import Vue from 'vue';
import URLS from '~/URLS';

type QuestionAnswer = {
    question: string;
    answer: string;
};

export default Vue.extend({
    name: 'AssessmentSection5',
    computed: {
        questionsLeft(): QuestionAnswer[] {
            return ['01', '02', '08', '06'].map(id => ({
                question: this.$t(`assessments.landing.section5.question${id}.q`) as string,
                answer: this.$t(`assessments.landing.section5.question${id}.a`, {
                    premiumLink: window.location.origin.concat(
                        URLS.assessments,
                        URLS.assessmentCenter,
                        '?goTo=premium'
                    ),
                }) as string,
            }));
        },
        questionsRight(): QuestionAnswer[] {
            return ['03', '04', '05', '07'].map(id => ({
                question: this.$t(`assessments.landing.section5.question${id}.q`) as string,
                answer: this.$t(`assessments.landing.section5.question${id}.a`, {
                    link: 'https://assessment.aon.com/en-us/prepare-your-assessment',
                }) as string,
            }));
        },
    },
});
